import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/img/logo.jpg'
import _imports_1 from '../../assets/img/icons/eye-close.svg'
import _imports_2 from '../../assets/img/icons/eye.svg'


const _hoisted_1 = { class: "login-wrapper d-flex flex-wrap overflow-hidden" }
const _hoisted_2 = { class: "login-form-wrap" }
const _hoisted_3 = { class: "login-form" }
const _hoisted_4 = { class: "form-group mb-15" }
const _hoisted_5 = { class: "form-group mb-20 position-relative" }
const _hoisted_6 = ["type"]
const _hoisted_7 = {
  key: 0,
  src: _imports_1,
  alt: "Show Password"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_2,
  alt: "Hide Password"
}
const _hoisted_9 = {
  key: 0,
  class: "text-danger mb-3"
}
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "login-bg" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo"
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Logo",
              class: "d-block mx-auto logo-custom-w-100"
            }, null, -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Username", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-title",
              placeholder: "Enter Username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Password", -1)),
            _withDirectives(_createElementVNode("input", {
              type: _ctx.passwordVisible ? 'text' : 'password',
              placeholder: "Enter Password",
              class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              required: ""
            }, null, 8, _hoisted_6), [
              [_vModelDynamic, _ctx.password]
            ]),
            _createElementVNode("span", {
              id: "toggler",
              class: "position-absolute",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
            }, [
              (!_ctx.passwordVisible)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_openBlock(), _createElementBlock("img", _hoisted_8))
            ])
          ]),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "alert alert-info mb-3" }, [
            _createElementVNode("small", null, [
              _createElementVNode("strong", null, "Demo Credentials:"),
              _createElementVNode("br"),
              _createTextVNode(" Username: "),
              _createElementVNode("code", null, "Admin"),
              _createElementVNode("br"),
              _createTextVNode(" Password: "),
              _createElementVNode("code", null, "password123")
            ])
          ], -1)),
          _createElementVNode("button", {
            type: "submit",
            class: "btn style-one w-100 d-block",
            disabled: _ctx.loading
          }, _toDisplayString(_ctx.loading ? "Logging in..." : "Login"), 9, _hoisted_10)
        ], 32)
      ])
    ])
  ]))
}